import { useState, useEffect } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box } from '@mui/material';
import Tab4 from './Tab1';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/Caisse2';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import CheckStan from "../../Prints/CheckStan";
import { IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import Caisse from "../../../Models/Caisse";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { Person } from "@mui/icons-material";




const CreateCaisse = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Liblibelle, setLiblibelle] = useState(false);

     const [DataBranch, SetDataBranch] = useState<Caisse[]>([]);
      const [currentDataBranch, setCurrentDataBranch] = useState<Caisse | null>(null);
        
    const [searchTerm, setSearchTerm] = useState('');
        const [page, setPage] = useState(0); // Page actuelle
         const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
        const [error, setError] = useState<string | null>(null);
          const [loading2, setLoading2] = useState(false);
        

let searchComptes: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'AGCCPT ', Choix: 22 }
//pour les caisses
let searchCaisse: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", Colagence: 'AEGECE', Choix: 22 }

//pour les agences
let searchAgence: ParamsPicklist = { CodeAgence: Perss.codage, Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: 'CODAGE', Choix: 22 }

//pour les Comptes
//let searchComptes: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
//pour les numcli
let searchNumcli: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 }

//pour les numcli
let searchUtilis: ParamsPicklist = { CodeAgence: Perss.codage, Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: 'CODAGE', Choix: 22 }



    const dataOption2: DataSelect[] = [
        { label: "Caisse Principal", value: "P" },
        { label: "Caisse Secondaire", value: "S" }
    ]

    useEffect(() => {
        loadAllDataBranch();
    }, []);

    // Handle function
    function HandleConsult() {
        //setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        setIdbutton(false)
        setLiblibelle(true)
    }

    function HandleAjout() {
         HandleAnnul();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')
        setIdbutton(false)
        setLiblibelle(false)
    }

    function HandleModif() {
         setAjoute(true)
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        setIdbutton(true)
        setLiblibelle(false)
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
    }

// 📄 Filtrage des données en fonction du terme de recherche
  const filteredDataBranch = DataBranch.filter((item) =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  // 📄 Pagination après filtrage
  const paginatedDataBranch = filteredDataBranch.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
// --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
  const handleOpenDialog = (DataToEdit: Caisse | null = null) => {
    if (DataToEdit) {
      setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
      form.setFieldsValue({...DataToEdit})
      HandleModif()
     // console.log(DataToEdit)
    } else {
      // Initialiser un nouvel objet avec des valeurs par défaut
    //   setCurrentDataBranch({
    //   NODECE : "string",
    // LECEON : "string",
    // CDETAT : "string",
    // AEGECE : "string",
    // NMURCR : "string",
    // EEDTJE : 0,
    // EETSRL : 0,
    // MTESFD : 0,
    // MTRSFD : 0,
    // EEPEAE : 0,
    // NEDSTE : 0,
    // CLOSPT : 0,
    // CLOSVT : 0,
    // NUMRET : 0,
    // NUMVER : 0,
    // CAIUTI : "0",
    // TYPCAI : "0",
    // DRNOSE : 0,
    // NUMCPT : "0",
    
    //   });
    }
   // setOpenDialog(true);
   // setDialogError(null); // Réinitialiser les erreurs du dialogue
  };

 
    async function loadAllDataBranch() {
      
        setLoading2(true);
        setError(null);
        try {
        
     // console.log(apiEndpoints.bureaux)
      var params = { CodeAgence: Perss.codage , Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", Colagence: "AEGECE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
      console.log(params)
      const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
      
      if (data.length!==0)
         {
    // alter(data.result)
      //console.log(data)
         SetDataBranch(data); // ou console.log(data)
         }
        }catch (err) {
      console.error("Erreur de chargement:", err);
      setError("Impossible de charger les données .");
     } finally {
      setLoading2(false);
     }
    } ;

// 🔁 Gestion du changement de page
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  
  };

  // 🔁 Gestion du changement de nombre de lignes
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Revenir à la première page après changement
  };


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Création Caisse
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <legend> Mise en place caisse </legend>

                            <Box style={{ display: 'flex' }}>
                                <Box style={{ width: '50%' }}>
                                    <fieldset className="bordure1" style={{ marginTop: -20 }}>
                                        {/* <Box style={{ marginTop: -5, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Code Agence" Parametre={searchAgence} name="AEGECE" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box> */}
                                        <Box style={{ marginTop: -10, width: '100%' }}>                 {/*   Libelle LECEON  */}
                                            <SearInputG width={8} dissabledLib={Liblibelle} notremove dissabledCode={Idbutton} Titre=" Recherche" label='Numéro Caisse' name="NODECE" Taille1={'100%'} Taille2={'100%'} Parametre={searchCaisse} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Titulaire" Parametre={searchUtilis} name="NMURCR" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, marginBottom: -5, width: '90%' }}>
                                            < SelectOption Option={dataOption2} width={9} label="Type de caisse" Size={'90%'} name="TYPCAI" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '90%' }}>
                                            <InputForm width={9} label="Encaisse physique" type="number" name="EETSRL" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '90%' }}>
                                            <InputForm width={9} label="Excédent/manquant Max" type="number" name="manqmax" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Chef de Caisse" Parametre={searchUtilis} name="CHEFCAI" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Numéro Compte caisse" Parametre={searchComptes} name="NUMCPT" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Compte manquant" name="CPTMAD" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Compte excedent" name="CPTEXD" Parametre={searchComptes} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Cpte Emission/Reception Fond" Parametre={searchComptes} name="CPTEMIRECFONDS" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={8} Titre="" label="Compte manquant excedentaire" Parametre={searchComptes} name="seccptmanq" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </fieldset>
                                </Box>
                                <Box style={{ marginTop: 0, width: '50%' }}>
                                    <fieldset className="bordure1" style={{ marginTop: -20 }}>
                                        <Box style={{ paddingLeft: 15, marginBottom: -25, width: '100%' }}>
                                            <CheckStan width={10} label={"Voir encaisse informatique ?"} name={"isEncInf"} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Manquant max autorisé" type="number" name="maxmanq" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Solde caisse max autorisé" type="number" name="encaiMaxAuto" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libelle total versement" type="text" name="LIBVER" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libelle total retrait" type="text" name="LIBRET" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libellé arrêté" type="text" name="LIBARR" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libellé total entrées fonds" type="text" name="libentfd" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libellé total Ssrties fonds" type="text" name="libsortfd" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libellé total emmission fonds" type="text" name="libEmisFd" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={10} label="Libellé total reception fonds" type="text" name="libRecepFd" />
                                        </Box>
                                    </fieldset>
                                </Box>

                            </Box>
                                <Box style={{ width: '100%' }}>
                                    <fieldset className="bordure1"  >
                                        {/* Zone de recherche */}
                                              <Box sx={{ mb: 2 }}>
                                                <TextField
                                                  label="Recherche"
                                                  variant="outlined"
                                                  fullWidth
                                                  
                                                  value={searchTerm}
                                                   onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(0); // Remettre à la page 0 après recherche
                                                  }}
                                                  size="small"
                                                  InputLabelProps={{
                                                      sx: {
                                                        fontWeight: 'bold',
                                                              },
                                                             }}
                                                  InputProps={{
                                                     endAdornment: (
                                                     <InputAdornment position="end">
                                                     <SearchIcon color="action" />
                                                     </InputAdornment>
                                                                 ),
                                                             }}
                                                />
                                               
                                              </Box>
                                            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                                              
                                         <TableContainer component={Paper} elevation={3} sx={{ width: '100%', overflowX: 'auto', overflowY: 'auto' }}>
                                                
                                            <Table stickyHeader size="small" sx={{ minWidth: 850 }}>
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell sx={{ minWidth: 100, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Code</TableCell>
                                                  <TableCell sx={{ minWidth: 160, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Libellé</TableCell>
                                                  <TableCell sx={{ minWidth: 120, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Titulaire</TableCell>
                                                  <TableCell sx={{ minWidth: 140, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Compte</TableCell>
                                                  <TableCell sx={{ minWidth: 120, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Créé le</TableCell>
                                                  <TableCell sx={{ minWidth: 120, fontWeight: 'bold', whiteSpace: 'nowrap' }}>Créé par</TableCell>
                                                 {/* <TableCell>Actions</TableCell>   */}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {paginatedDataBranch.length === 0 ? (
                                                  <TableRow>
                                                    <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                                                  </TableRow>
                                                ) 
                                                : (
                                                  paginatedDataBranch.map((item) => (
                                                    <TableRow hover key={`${item.NODECE}-${item.LECEON}-${item.AEGECE}`} sx={{ cursor: 'pointer' }} >
                                                                 {/* Clé unique pour React */}
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>{item.NODECE}</TableCell>
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>{item.LECEON}</TableCell>
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>{item.CAIUTI}</TableCell>
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>{item.NUMCPT}</TableCell>
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                                                      <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>{item.UTILIS ?? 'N/A'}</TableCell>
                                                     
                                                       <TableCell sx={{ py: 1, whiteSpace: 'nowrap', fontSize: 13 }}>
                                                        {/* <IconButton color="primary" onClick={() => handleOpenDialog(item)}>
                                                          <EditIcon />
                                                        </IconButton>
                                                        <IconButton color="error" onClick={() => HandleSupp()}>
                                                          <DeleteIcon />
                                                        </IconButton> */}
                                                      </TableCell> 
                                                      
                                                    </TableRow>
                                                  ))
                                                )}
                                              </TableBody>
                                            </Table>
                                        </TableContainer>
                                         {/* Pagination */}
                                              <TablePagination
                                                component="div"
                                                count={filteredDataBranch.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                labelRowsPerPage="Lignes par page"
                                              />
                                    </fieldset>
                                 </Box>
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];

    // function consult 
    function consult() {
       
        if (form.getFieldValue("NODECE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le Id Caisse", icon: "warning" });
        } else {
            HandleConsult()
            let data = (form.getFieldValue("NODECE"));

            if (data.length != 0) {
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadCaisse2,
                    headers: {
                        'CypherCaisse ': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            console.log(DemandVP);

                            if (res.StatutCode == 200) 
                            {
                                form.setFieldsValue(DemandVP);
                                form.setFieldValue("lib_NODECE", DemandVP.LECEON);
                                 loadAllDataBranch();
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: Demand = values
        Demand.UTILIS = Perss.coduti
        Demand.DATCRE = formatDate(Perss.datjour)
        Demand.DATMOD = formatDate(Perss.datjour)
        Demand.LECEON = form.getFieldValue("lib_NODECE")
        Demand.UTISAI = Perss.coduti
        Demand.AEGECE = Perss.codage

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'une Caisse",
                text: "Voulez-vous Créer la caisse de " + form.getFieldValue("lib_NODECE"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateCaisse2,
                        headers: {
                            'CypherCaisse': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                                       
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                    

                                if (res.StatutCode == 200) 
                                {
                                    SweetAlert.fire({ title: res.Result , text: res.Message, icon: "success" })
                                    form.resetFields();
                                    loadAllDataBranch();
                                    
                                }
                                else SweetAlert.fire({ title: res.Message, text: res.Message, icon: "warning" })
                                
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Mise à Jour d'une Caisse",
                text: "Voulez-vous Mettre à jour la caisse de " + form.getFieldValue("NODECE") + ' : ' + form.getFieldValue("lib_NODECE")!='undefined'?form.getFieldValue("lib_NODECE"):"",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateCaisse2,
                        headers: {
                            'CypherCaisse': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) 
                                 {
                                   SweetAlert.fire({ title: res.Result , text: res.Message, icon: "success" })
                                        HandleAnnul()
                                 }
                              else  SweetAlert.fire({ title: res.Result, text: res.Message, icon: "warning" })                               
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'une Caisse",
                text: "Voulez-vous Supprimer la caisse de " + form.getFieldValue("lib_NODECE"),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.NODECE));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteCaisse2,
                        headers: {
                            'CypherCaisse': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>

                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button> 
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button> */}
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default CreateCaisse;